import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import * as styles from "./styles.module.css";

export function EntityCard({ title, subline, image, bottom, linkTo }) {
  return (
    <Link to={linkTo} className={styles.entityCard}>
      <h3 className={styles.title} title={title}>
        {title}
      </h3>
      <div className={styles.subline}>{subline}</div>
      {typeof image === "string" && (
        <img src={image} alt={title} className={styles.image} />
      )}
      {image && typeof image !== "string" && (
        <GatsbyImage
          image={getImage(image)}
          alt={title}
          className={styles.image}
        />
      )}
      {!image && <div className={styles.imagePlaceholder} />}
      {bottom && (
        <div
          className={styles.bottom}
          title={typeof bottom === "string" ? bottom : undefined}
        >
          {bottom}
        </div>
      )}
    </Link>
  );
}
